import {getSize, Icon, ThemeColorPath, ThemeIconKey} from 'platform/foundation';
import {cn, cva} from 'platform/shared';

import {ReactNode} from 'react';

import {TestIdProps} from 'shared/web';

const ICON_SIZE = 4;
const ICON_COLOR: ThemeColorPath = 'palettes.neutral.500.100';
/** Gap between the icon and the gauge when the caller does not override it. */
const DEFAULT_GAP = 2;

export interface LevelInputRowProps extends TestIdProps {
  icon: ThemeIconKey;
  /** Outline icons (the fuel pump) are drawn with a stroke instead of a fill. */
  isIconNotFilled?: boolean;
  isDisabled?: boolean;
  /** Raw CSS length, for the rows whose spec gap is off the 4px grid. */
  gap?: string;
  /** Rendered before the icon, for the controls that read ahead of the gauge. */
  leading?: ReactNode;
  children: ReactNode;
}

const rowVariants = cva('flex h-[calc(var(--eag-space-step,0.25)*8rem)] select-none items-center', {
  variants: {
    isDisabled: {
      true: 'pointer-events-none opacity-[0.45]',
      false: '',
    },
  },
});
const leadingSlotVariants = cva('contents select-text');
const iconSlotVariants = cva('flex-none leading-[0]');

/** The leading icon and the flex row both level gauges are laid out in. */
export function LevelInputRow(props: LevelInputRowProps) {
  return (
    <div
      className={cn(rowVariants({isDisabled: props.isDisabled ?? false}))}
      style={{gap: props.gap ?? getSize(DEFAULT_GAP)}}
      data-testid={props['data-testid']}
    >
      <div className={cn(leadingSlotVariants())}>{props.leading}</div>
      <div className={cn(iconSlotVariants())}>
        <Icon
          value={props.icon}
          size={ICON_SIZE}
          color={ICON_COLOR}
          isNotFilled={props.isIconNotFilled}
        />
      </div>
      {props.children}
    </div>
  );
}
